import { render, staticRenderFns } from "./SparePartsReport.vue?vue&type=template&id=7f80e80e&scoped=true"
import script from "./SparePartsReport.vue?vue&type=script&lang=js"
export * from "./SparePartsReport.vue?vue&type=script&lang=js"
import style0 from "./SparePartsReport.vue?vue&type=style&index=0&id=7f80e80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80e80e",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Freports%2Fspare-parts-report%2FSparePartsReport.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports